// src/components/breadcrumb/breadcrumb.styles.ts
import { css } from "lit";
var breadcrumb_styles_default = css`
  .breadcrumb {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
`;

export {
  breadcrumb_styles_default
};
